// extracted by mini-css-extract-plugin
export default {"inner":"TrainingProgramWorkoutPage_inner__5n47A"};